import { lazy } from "react";

export const LazyIdentitySwitcherDropdown = lazy(async () => ({
    default: (await import("./IdentitySwitcherDropdown"))
        .IdentitySwitcherDropdown
}));
